export const TOP_WINNERS_TABLE = 'top-winners-table';
